

















import { computed, defineComponent, toRefs, ref } from '@nuxtjs/composition-api'
import draggable from 'vuedraggable'
export default defineComponent({
  components: { draggable },
  props: {
    value: {
      type: Array,
      default() {
        return []
      }
    },
    animation: {
      type: [String, Number],
      default: '200'
    },
    handle: {
      type: String,
      default: null
    }
  },
  setup(props: any, { emit }: any) {
    const { value } = toRefs(props)
    const isDisabled = ref(false)

    const internalValue = computed({
      get(): string {
        return value.value
      },
      set(newValue: string): void {
        emit('input', newValue)
      }
    })

    function handleChoose(e) {
      if (e.item.dataset.disabled === 'true') {
        isDisabled.value = true
      }
    }
    function handleUnchoose() {
      isDisabled.value = false
    }

    return { internalValue, handleUnchoose, handleChoose, isDisabled }
  }
})
